module.exports = __webpack_public_path__ + "static/media/Icono sucursales.4fc155ab.svg";